import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/base.css'
import '../public/js/font.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import storage_ from '../public/js/storage.js'
import publicUrl from '../public/path/publicUrl.js'
import md5 from 'js-md5'
// 组件中引入
// import wxlogin from 'vue-wxlogin'
// require styles
import 'swiper/dist/css/swiper.css'
import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import MetaInfo from 'vue-meta-info'
Vue.use(Element)
Vue.use(MetaInfo)
Vue.use(VueAwesomeSwiper)
Vue.prototype.$publicUrl = publicUrl
Vue.prototype.$storage = storage_
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
        if (store.state.token) { // 通过vuex state获取当前的token是否存在
            // chrome
            document.body.scrollTop = 0
            // firefox
            document.documentElement.scrollTop = 0
            // safari
            window.pageYOffset = 0
            next();
        } else {
            document.body.scrollTop = 0
            // firefox
            document.documentElement.scrollTop = 0
            // safari
            window.pageYOffset = 0
            next({
                path: '/login',
                query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
            next();
        }
    } else {
        next();
    }




})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
